export const PRODUCT_REVIEWS_ID = 'product-reviews';
export const MAIN_PAGE_CTA_ID = 'main-page-cta';
